import React, { FC } from 'react';

import { SearchListType } from '../types';

import { getMessage } from './helpers';
import * as Styled from './styled';
import { Reason } from './types';

export type Props = {
  reason: Reason;
  type: SearchListType;
};

/**
 * No result for searching items
 *
 * @param props        Props passed to the component
 * @param props.reason Why is there nothing to show
 * @param props.type   The type of the list (members/groups/labels)
 * @returns            The component itself
 */
const EmptySearch: FC<Props> = ({ reason, type }) => {
  return <Styled.Title>{getMessage(reason, type)}</Styled.Title>;
};

export default EmptySearch;
